'use client'

import Link from 'next/link'
import { useEffect, useRef } from 'react'
import { HiChevronRight, HiHome } from 'react-icons/hi'
import { getNativeReaderHref } from 'helpers/nativeReaderHref'

export type BreadcrumbItem = {
  label: string
  href?: string
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
}

const Breadcrumb = ({ items }: BreadcrumbProps) => {
  const scrollRef = useRef<HTMLElement>(null)

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft = scrollRef.current.scrollWidth
    }
  }, [items])

  return (
    <nav
      ref={scrollRef}
      className="flex my-4 overflow-x-auto whitespace-nowrap no-scrollbar"
      aria-label="Breadcrumb"
    >
      <ol className="inline-flex items-center space-x-1 md:space-x-2">
        <li className="inline-flex items-center">
          <Link
            href="/"
            className="inline-flex items-center text-sm text-gray-700 hover:text-primary-600 dark:text-gray-300 dark:hover:text-white"
          >
            <HiHome className="shrink-0 w-4 h-4 mr-2" />
            Ana Sayfa
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="inline-flex items-center">
            <HiChevronRight className="shrink-0 w-5 h-5 text-gray-400" />
            {item.href ? (
              <Link
                href={getNativeReaderHref(item.href)}
                className="ml-1 text-sm text-gray-700 hover:text-primary-600 dark:text-gray-300 dark:hover:text-white md:ml-2"
              >
                {item.label}
              </Link>
            ) : (
              <span className="ml-1 text-sm font-medium text-gray-500 dark:text-gray-400 md:ml-2">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}

export default Breadcrumb
